"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _utils = require("../../../../../../common/utils");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function getPreview(_ref, type) {
  var assetId = _ref.assetId,
      _ref$assetFiles = _ref.assetFiles,
      assetFiles = _ref$assetFiles === void 0 ? {} : _ref$assetFiles;
  var _assetFiles$ORIGINAL = assetFiles.ORIGINAL,
      ORIGINAL = _assetFiles$ORIGINAL === void 0 ? {} : _assetFiles$ORIGINAL,
      _assetFiles$THUMBNAIL = assetFiles.THUMBNAIL,
      THUMBNAIL = _assetFiles$THUMBNAIL === void 0 ? {} : _assetFiles$THUMBNAIL;
  var thumbnailSourceUrl = THUMBNAIL ? THUMBNAIL.sourceUrl : '';

  switch (type) {
    case 'IMAGE':
      return _react.default.createElement("div", {
        className: "files-preview__sample"
      }, _react.default.createElement(_uiKit.Image, {
        imageUrl: ORIGINAL.sourceUrl,
        defaultImageIcon: "image",
        defaultIconColour: "russian",
        width: "90px",
        height: "90px",
        backgroundSize: "cover"
      }));

    case 'FONT':
      return _react.default.createElement("div", {
        className: "files-preview__sample-text"
      }, _react.default.createElement("span", {
        style: {
          fontFamily: "".concat((0, _utils.getFontFamily)(assetId))
        }
      }, "Abc"));

    case 'VIDEO':
      return (
        /* eslint-disable jsx-a11y/media-has-caption */
        _react.default.createElement("div", {
          className: "files-preview__sample"
        }, thumbnailSourceUrl ? _react.default.createElement(_uiKit.Image, {
          imageUrl: thumbnailSourceUrl,
          defaultImageIcon: "video",
          defaultIconColour: "russian",
          width: "90px",
          height: "90px"
        }) : _react.default.createElement("video", {
          src: ORIGINAL.sourceUrl
        }))
        /* eslint-enable jsx-a11y/media-has-caption */

      );

    case 'DOC':
      return _react.default.createElement("div", {
        className: "files-preview__sample"
      }, _react.default.createElement(_uiKit.Image, {
        defaultImageIcon: "document",
        defaultIconColour: "russian",
        width: "90px",
        height: "90px"
      }));

    default:
      return null;
  }
}

function FilePreview(_ref2) {
  var deleteAsset = _ref2.deleteAsset,
      type = _ref2.type,
      asset = _ref2.asset,
      buttonTitle = _ref2.buttonTitle,
      openAssetModal = _ref2.openAssetModal;

  if (!asset) {
    return null;
  }

  return _react.default.createElement("div", {
    className: "files-preview"
  }, _react.default.createElement(_uiKit.Icon, {
    className: "files-preview__close-button",
    name: "close",
    size: 15,
    color: "regent",
    onClick: deleteAsset
  }), _react.default.createElement("div", {
    className: "files-preview__main"
  }, getPreview(asset, type), _react.default.createElement("p", {
    className: "files-preview__name"
  }, asset.filename), _react.default.createElement(_uiKit.Button, {
    type: "INVERTED",
    small: true,
    onClick: openAssetModal
  }, buttonTitle)));
}

var _default = (0, _react.memo)(FilePreview);

exports.default = _default;